import { SET_EMAIL_FIELD_DATA, TOOGLE_AGREEMENT_FIELD_DATA } from './constants';

const initialState = {
  emailFieldData: '',
  requiredMessage: 'Обязательное поле',
  invalidMessage: 'Некорректный e-mail',
  agreementUncheckedState: {},
  agreementDataUrl: '/shop/sitetext/?key=SHOP_BASKET_SALES_AGREEMENT_POPUP',
};

export default function (state = initialState, action) {
  switch (action.type) {
    case SET_EMAIL_FIELD_DATA: {
      return {
        ...state,
        emailFieldData: action.payload,
      };
    }
    case TOOGLE_AGREEMENT_FIELD_DATA: {
      return {
        ...state,
        agreementUncheckedState: {
          ...state.agreementUncheckedState,
          ...{ ...action.payload },
        },
      };
    }
    default:
      return state;
  }
}
